import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Helper } from "src/app/shared/utils/helper";
import { MenueItems } from './menus';
import * as _ from 'lodash';
import { AuthService } from 'src/app/services/auth.service';
@Component({
    selector: 'app-sidemenu',
    templateUrl: './side-menu.html',
    styles: []
  })
export class SidemenuComponent{
  menueList = [];
  menus = new MenueItems();
  moduleName = '';

  constructor(private router:Router,
    private authService: AuthService,
    private route: ActivatedRoute
    ){}
  ngOnInit() {
    this.menueList = this.menus.menusList;
  }
  ngAfterViewInit() {
  }

  hasSub(subMenu) {
    if (!Helper.isEmpty(subMenu) && subMenu instanceof Array && subMenu.length > 0) {
      return false;
    }
    return true;
  }

  goto(module, path) {
    this.moduleName = module;
    const fullPath = `cit/${module}/${path}`;
    console.log(fullPath);

    this.router.navigate([fullPath]);
    return false;
  }

  toModule(menu) {
    if (menu.submenue != null) {
      const child = menu.submenue[0].path;
      return `/#/cit/${menu.module}/${child}`;
    }
    return `/#/cit/${menu.module}/${menu.path}`;
  }

  currentModule() {
    if (Helper.isEmpty(this.moduleName)) {
      const p = this.router.url;
      const np = _.split(p, '/');
      this.moduleName = np[2];
    }

    if (this.moduleName == undefined) {
      return this.moduleName = "cit";
    }
    return this.moduleName;
  }

  currentPath(module, path) {
    const p = `/cit/${module}/${path}`;
    if (this.router.url.includes(p)) {
      return true;
    }
    return false;
  }

  hasPermission(permission) {
    if (permission == null) {
      return false;
    }
    return Helper.hasPermission(permission);
  }

  menuPermissions(permission: [], menu): boolean {
    if (menu && menu.module =="dashboard/cod" && !Helper.getUserObject('IsCod')) {
      return false;
    }
    let bl = false;
    if (permission == null) {
      return bl;
    }
    _.each(permission, (o) => {
      if (this.hasPermission(o)) {
        bl = true;
      }
    });
    return bl;
  }

  closeNav(menu): void {
    this.moduleName = menu.module;
  }

  navItem(menu) {
    let s = "";
    if (menu.class) {
      s += menu.class;
    }
    if (menu.module === this.moduleName) {
      // s+= " menu-open";
    }
    return s;
  }

  get usersInfo(): boolean {
    return !!Helper.getUserObject("permissions");
  }

  /** side menu settings */
  get windowWidth() {
    return window.innerWidth;
  }
}
